export default "__VITE_ASSET__DnfO79lX__"